import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'UserInterfaceLayout.Title',
    defaultMessage: 'Layout Options'
  },
  fixedWidthTitle: {
    id: 'UserInterfaceLayout.FixedWidth.Title',
    defaultMessage: 'Fixed Width'
  },
  fixedWidthDescription: {
    id: 'UserInterfaceLayout.FixedWidth.Description',
    defaultMessage: 'Good for apps with simple data entry or limited functionality. Desktop view is the same as mobile.'
  },
  expandableTitle: {
    id: 'UserInterfaceLayout.Expandable.Title',
    defaultMessage: 'Expandable'
  },
  expandableDescription: {
    id: 'UserInterfaceLayout.Expandable.Description',
    defaultMessage:
      'Responsive design with the ability to expand. Good for apps that could benefit from more screen real estate.'
  },
  defaultExpandedTitle: {
    id: 'UserInterfaceLayout.DefaultExpanded.Title',
    defaultMessage: 'Expanded by Default'
  },
  defaultExpandedDescription: {
    id: 'UserInterfaceLayout.DefaultExpanded.Description',
    defaultMessage:
      'This setting will open expanded by default, but is still collapsable by the user. Appropriate for apps that display best with greater screen real estate.'
  }
})
